import React from 'react';

export const TogglesPanel = ({ form, onChange, pickerServices }) => (
  <div className="panel" style={{ padding: '6px 18px' }}>
    <div className="toggle-row">
      <div className="tx">
        <b>Require a deposit</b>
        <small>Taken at booking to cut no-shows</small>
        {form.deposit_required && (
          <div className="deposit-config">
            <div className="deposit-mode-row">
              <div className="mode-seg" role="tablist" aria-label="Deposit type">
                <button
                  type="button"
                  role="tab"
                  aria-selected={(form.deposit_type || 'fixed') === 'fixed'}
                  className={`seg-btn ${(form.deposit_type || 'fixed') === 'fixed' ? 'on' : ''}`}
                  onClick={() => onChange({ deposit_type: 'fixed' })}
                  data-testid="deposit-mode-fixed"
                >£ Fixed</button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={form.deposit_type === 'percent'}
                  className={`seg-btn ${form.deposit_type === 'percent' ? 'on' : ''}`}
                  onClick={() => onChange({ deposit_type: 'percent' })}
                  data-testid="deposit-mode-percent"
                >% of price</button>
              </div>
              <div className="deposit-amt">
                {(form.deposit_type || 'fixed') === 'fixed' ? '£' : ''}
                <input
                  type="number"
                  min="1"
                  step="1"
                  value={form.deposit_amount}
                  onChange={(e) => onChange({ deposit_amount: e.target.value })}
                  data-testid="deposit-amount"
                  placeholder={form.deposit_type === 'percent' ? '20' : '10'}
                />
                {form.deposit_type === 'percent' ? '%' : ''}
                <span className="unit-suffix">
                  {form.deposit_type === 'percent' ? 'of each service price' : 'per booking'}
                </span>
              </div>
            </div>
            {form.deposit_type === 'percent' && Number(form.deposit_amount) > 0 && pickerServices.length > 0 && (
              <div className="deposit-preview" data-testid="deposit-preview">
                <div className="dp-h">Preview per service (rounded up)</div>
                <ul className="dp-list">
                  {pickerServices.map((s) => {
                    const price = Number(s.price || 0);
                    const pounds = Math.ceil((price * Number(form.deposit_amount)) / 100);
                    return (
                      <li key={s.id}>
                        <span className="dp-name">{s.name}</span>
                        <span className="dp-arrow">£{price.toFixed(0)} →</span>
                        <span className="dp-val">£{pounds}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
      <button
        type="button"
        className={`tog ${form.deposit_required ? '' : 'off'}`}
        onClick={() => onChange({ deposit_required: !form.deposit_required })}
        data-testid="toggle-deposit"
        aria-label="Toggle deposit"
      />
    </div>
    <div className="toggle-row">
      <div className="tx">
        <b>Show opening hours</b>
        <small>Display your shop hours on the booking page</small>
      </div>
      <button
        type="button"
        className={`tog ${form.show_hours ? '' : 'off'}`}
        onClick={() => onChange({ show_hours: !form.show_hours })}
        data-testid="toggle-hours"
        aria-label="Toggle show hours"
      />
    </div>
    <div className="toggle-row">
      <div className="tx">
        <b>Let customers choose barber</b>
        <small>If off, we&apos;ll auto-assign the next available barber</small>
      </div>
      <button
        type="button"
        className={`tog ${form.allow_choose_barber ? '' : 'off'}`}
        onClick={() => onChange({ allow_choose_barber: !form.allow_choose_barber })}
        data-testid="toggle-choose-barber"
        aria-label="Toggle choose barber"
      />
    </div>
  </div>
);
